var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24.6296C0 11.0271 11.0271 0 24.6296 0C38.2322 0 49.2592 11.0271 49.2592 24.6296C49.2592 38.2322 38.2322 49.2592 24.6296 49.2592C11.0271 49.2592 0 38.2322 0 24.6296Z",
    fill: "#0C94FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2146 12.6836C17.0875 13.0573 12.3828 18.6661 12.6801 25.7389C12.8099 28.8347 14.0501 31.4985 14.344 34.4366C14.4191 35.1977 14.2005 36.1371 15.0751 36.4697C16.1514 36.8776 17.8016 36.192 18.7036 35.5646C19.0111 35.3554 19.3049 35.112 19.5304 34.8103C20.4632 35.4309 21.3481 36.0308 22.4585 36.2982C27.3477 37.4742 32.7049 34.7829 35.0863 30.4597C39.5621 22.3379 33.5113 12.1968 24.2146 12.6836ZM21.4471 29.6335C21.0611 29.9352 20.6886 30.3466 20.2616 30.5831C19.6432 30.9157 19.4518 30.5694 19.2195 30.0209C18.4883 28.2759 18.3995 25.3035 18.8266 23.4761C19.4006 20.9906 21.3173 18.8033 23.9515 18.5701C26.6165 18.3336 29.0901 19.6912 30.2074 22.1425C32.681 27.597 26.35 32.983 21.4471 29.6369V29.6335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMax);
export default __webpack_public_path__ + "static/media/max.4b011149f014bdce2ef6f1d0778661c6.svg";
export { ForwardRef as ReactComponent };